<ion-card
  (click)="abrirNoticia()"
  [ngClass]="{
    'margem-0': config.margem == '0',
    'margem-1': config.margem == '1'
  }"
>
  <div class="container">
    <div class="data-card" *ngIf="config.mostrar_data == '1'">
      <div style="display: grid; justify-content: center; align-items: center">
        <div class="mes">{{ getMes() }}</div>
        <div class="dia">{{ getDia() }}</div>
      </div>
    </div>
    <img [src]="config.image | image : 'evento'" />
  </div>
</ion-card>
